import Card from '../ui/Card';

/** Placeholder sized like ResourceCard while a WordPress post is still loading. */
export default function ResourceCardSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading resource">
      <Card className="!p-4">
        <div className="flex items-start gap-3">
          <div className="min-w-0 flex-1 space-y-2">
            <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
            <div className="h-5 max-w-xl bg-gray-200 rounded animate-pulse" style={{ width: '80%' }} />
          </div>
          <div className="h-10 w-10 flex-shrink-0 bg-gray-200 rounded animate-pulse" />
        </div>
        <div className="mt-2 h-4 w-48 bg-gray-200 rounded animate-pulse" />
        <div className="mt-2 h-4 max-w-lg bg-gray-200 rounded animate-pulse" style={{ width: '100%' }} />
        <div className="mt-3 h-4 w-40 bg-gray-200 rounded animate-pulse" />
        <div className="mt-3 h-5 w-12 bg-gray-200 rounded animate-pulse" />
      </Card>
    </div>
  );
}
